import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=ba22175a&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=ba22175a&prod&lang=less&scoped=true"
import style1 from "./UserMenu.vue?vue&type=style&index=1&id=ba22175a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba22175a",
  null
  
)

export default component.exports